import script from "./PricingPlans.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingPlans.vue?vue&type=script&setup=true&lang=js"

import "./PricingPlans.vue?vue&type=style&index=0&id=485cb45f&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\banjara_matrimonial\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-485cb45f"]])

export default __exports__